import { Component, Input, OnInit } from '@angular/core';
import { ListService } from '@app/common/services/list.service';

@Component({
  templateUrl: './occupations-change-final-solution-type.component.html',
  styleUrls: ['./occupations-change-final-solution-type.component.scss']
})
export class OccupationsChangeFinalSolutionTypeComponent implements OnInit {
  @Input() data: any;
  @Input() notifyParent: Function;

  inputData: any = {};
  occupationSolutionTypeOptions: any[] = [];

  constructor(private listService: ListService) {}

  async ngOnInit() {
    this.occupationSolutionTypeOptions = await this.listService
      .fetchResult(this.listService.createList('occupation-solution-types', { limit: null }))
      .then(data => data.list.slice(1));
    this.inputData = this.data.details || {};
    this.updated();
  }

  isCancelled(): boolean {
    return this.inputData.occupationSolutionType && this.inputData.occupationSolutionType.key === 'CANCELLED';
  }

  updated() {
    if (!this.isCancelled()) {
      this.inputData.finalSolutionReasonCancellation = null;
    }
    const isValid = !!this.inputData.occupationSolutionType &&
      (!this.isCancelled() || !!(this.inputData.finalSolutionReasonCancellation || '').trim());
    this.notifyParent(() => isValid, this.inputData);
  }
}
